var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    width: 18.31,
    height: 18.31,
    viewBox: "0 0 18.31 18.31",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M16.165,1.431h-.858V0H13.876V1.431H4.435V0H3V1.431H2.146A2.148,2.148,0,0,0,0,3.576V16.165A2.148,2.148,0,0,0,2.146,18.31H16.165a2.148,2.148,0,0,0,2.146-2.146V3.576A2.148,2.148,0,0,0,16.165,1.431Zm.715,14.734a.716.716,0,0,1-.715.715H2.146a.716.716,0,0,1-.715-.715V6.723H16.88Zm0-10.872H1.431V3.576a.716.716,0,0,1,.715-.715H3V4.292H4.435V2.861h9.441V4.292h1.431V2.861h.858a.716.716,0,0,1,.715.715Z",
    fill: "#586682"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(2.317 8.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 2,
    transform: "translate(-0.317 0.094)",
    fill: "#586682"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(6.372 8.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    transform: "translate(-0.372 0.094)",
    fill: "#586682"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(8.689 8.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    transform: "translate(0.311 0.094)",
    fill: "#586682"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(11.585 8.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 1,
    transform: "translate(0.415 0.094)",
    fill: "#586682"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(13.902 8.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 1,
    transform: "translate(0.098 0.094)",
    fill: "#586682"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(2.317 11.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 2,
    height: 1,
    transform: "translate(-0.317 0.198)",
    fill: "#586682"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(6.372 11.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    height: 1,
    transform: "translate(-0.372 0.198)",
    fill: "#586682"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(8.689 11.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    height: 1,
    transform: "translate(0.311 0.198)",
    fill: "#586682"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(11.585 11.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 1,
    height: 1,
    transform: "translate(0.415 0.198)",
    fill: "#586682"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(2.317 14.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 2,
    height: 1,
    transform: "translate(-0.317 -0.119)",
    fill: "#586682"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(6.372 14.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    height: 1,
    transform: "translate(-0.372 -0.119)",
    fill: "#586682"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(8.689 14.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    height: 1,
    transform: "translate(0.311 -0.119)",
    fill: "#586682"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(11.585 14.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 1,
    height: 1,
    transform: "translate(0.415 -0.119)",
    fill: "#586682"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(13.902 11.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 1,
    height: 1,
    transform: "translate(0.098 0.198)",
    fill: "#586682"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };